export const debounce = <T extends (...args: any[]) => void>(
    func: T,
    delay: number
) => {
    let timeoutId: NodeJS.Timeout | null = null;

    return (...args: Parameters<T>) => {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }

        timeoutId = setTimeout(() => {
            func(...args);
        }, delay)
    }
}

export interface MicrositeParams {
    origin:        string;
    userName:      string;
    claimId:       string;
    requirementId: string;
    memberNumber:  string;
  }

export const getMicrositeParams = (): MicrositeParams => {
  const qp = window.location.hash.includes("?")
    ? new URLSearchParams(window.location.hash.split("?", 2)[1])   // query after #
    : new URLSearchParams(window.location.search.substring(1));    // classic ?query

  return {
    origin:        qp.get("origin")        ?? "",
    userName:      qp.get("username")      ?? "",
    claimId:       qp.get("claimId")       ?? "",
    requirementId: qp.get("requirementId") ?? "",
    memberNumber:  qp.get("memberNumber")  ?? "",
  };
};
